// ssww-krushisetu\frontend\src\ColorFont\color.js

/* ================================================================
OLD UI CODE (COMMENTED OUT)
================================================================
import { themes } from "./themes";
import { fontThemes } from "./fontTheme";


if(! localStorage.getItem("theme") ){
  localStorage.setItem("theme", "classic");
}

if(! localStorage.getItem("fontTheme") ){
  localStorage.setItem("fontTheme", "classic");
}

const storedTheme = localStorage.getItem("theme") ;

const currentTheme = themes[storedTheme] || themes.classic;

const storedFontTheme = localStorage.getItem("fontTheme");

const currentFontTheme = fontThemes[storedFontTheme] || fontThemes.classic;

export const colors = {
  background_light: currentTheme.background_light,
  background2: currentTheme.background2,
  background3: currentTheme.background3,
  text: currentTheme.text,
  link: currentTheme.link,
  border: currentTheme.border,
  primary: currentTheme.primary,
  primary_dark: currentTheme.primary_dark,
  primary_light: currentTheme.primary_light,
  button: currentTheme.button,
  light: currentTheme.light,
  dark: currentTheme.dark,
  red: currentTheme.red,
  sold: currentTheme.sold,
};

// fonts family
export const fonts = {
  poppins: currentFontTheme.poppins,
};

//font size
export const size = {
  title: "24px",
  subtitle: "20px",
  label: "18px",
  text: "16px",
  formLabel: "14px",
};
*/

// ================================================================
// NEW UPDATED UI CODE (Universal Figma Mapping)
// ================================================================

import { themes } from "./themes";
import { fontThemes } from "./fontTheme";

// Set defaults if not present
if (!localStorage.getItem("theme")) {
  localStorage.setItem("theme", "default");
}

if (!localStorage.getItem("fontTheme")) {
  localStorage.setItem("fontTheme", "classic");
}

const storedTheme = localStorage.getItem("theme");
const baseTheme = themes.default;
const selectedTheme = themes[storedTheme] || baseTheme;
// Merge with baseTheme to ensure all Figma tokens exist even in custom themes
const currentTheme = { ...baseTheme, ...selectedTheme };

const storedFontTheme = localStorage.getItem("fontTheme");
const currentFontTheme = fontThemes[storedFontTheme] || fontThemes.classic;

// Apply CSS Variables globally to documentElement for use in CSS files
const root = document.documentElement;
root.style.setProperty("--primary-color", currentTheme.primary);
root.style.setProperty("--primary-dark-color", currentTheme.primary_dark);
root.style.setProperty("--primary-light-color", currentTheme.primary_light);
root.style.setProperty("--primary-font", currentFontTheme.poppins);
root.style.setProperty("--secondary-font", currentFontTheme.manrope);
root.style.setProperty("--tertiary-font", currentFontTheme.publicSans);
root.style.setProperty("--text-color", currentTheme.text);
root.style.setProperty("--text-dark-color", currentTheme.text_dark);
root.style.setProperty("--background-light", currentTheme.background_light);
root.style.setProperty("--border-color", currentTheme.border);

// Helper to generate RGBA from Hex
const hexToRGBA = (hex, alpha) => {
  if (!hex || !hex.startsWith('#')) return `rgba(0, 0, 0, ${alpha})`; // Neutral fallback
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const primary = currentTheme.primary;

// Inject Alpha Colors into CSS variables
root.style.setProperty("--primary-rgba-4", hexToRGBA(primary, 0.04));
root.style.setProperty("--primary-rgba-5", hexToRGBA(primary, 0.05));
root.style.setProperty("--primary-rgba-8", hexToRGBA(primary, 0.08));
root.style.setProperty("--primary-rgba-10", hexToRGBA(primary, 0.1));
root.style.setProperty("--primary-rgba-12", hexToRGBA(primary, 0.12));
root.style.setProperty("--primary-rgba-16", hexToRGBA(primary, 0.16));
root.style.setProperty("--primary-rgba-20", hexToRGBA(primary, 0.2));
root.style.setProperty("--primary-rgba-24", hexToRGBA(primary, 0.24));
root.style.setProperty("--primary-rgba-32", hexToRGBA(primary, 0.32));

export const colors = {
  background_light: currentTheme.background_light, // #FCFDFC
  background2: currentTheme.background2,
  background3: hexToRGBA(primary, 0.024),          // Dynamic fallback for theme tint (e.g. brown shade)
  text: currentTheme.text,                        // #6D786D
  text_dark: currentTheme.text_dark,              // #171C17
  link: currentTheme.link,                        // colors.primary
  border: currentTheme.border,                    // #E3E8E3
  primary: primary,                               // colors.primary
  primary_dark: currentTheme.primary_dark,        // #149343
  
  // Dynamic Alpha Colors for general use
  primary_rgba_4: hexToRGBA(primary, 0.04),
  primary_rgba_5: hexToRGBA(primary, 0.05),
  primary_rgba_8: hexToRGBA(primary, 0.08),
  primary_rgba_10: hexToRGBA(primary, 0.1),
  primary_rgba_12: hexToRGBA(primary, 0.12),
  primary_rgba_16: hexToRGBA(primary, 0.16),
  primary_rgba_20: hexToRGBA(primary, 0.2),
  primary_rgba_24: hexToRGBA(primary, 0.24),
  primary_rgba_32: hexToRGBA(primary, 0.32),

  google_bg: hexToRGBA(primary, 0.024),           // Dynamic fallback
  google_shadow: currentTheme.google_shadow,      // 0px 1px 2px #0000000D
  primary_light: hexToRGBA(primary, 0.3),         // Dynamic fallback (0.3 alpha)
  button: currentTheme.button,
  shadow_card: currentTheme.shadow_card,
  shadow_button_primary: currentTheme.shadow_button_primary,
  shadow_continue: currentTheme.shadow_continue,
  // Role Selection
  card_border_pale: currentTheme.card_border_pale,
  tag_bg: currentTheme.tag_bg,
  role_selected_bg: hexToRGBA(primary, 0.05),     // Dynamic fallback
  icon_bg_selected: primary,
  icon_bg_unselected: currentTheme.icon_bg_unselected,
  primary_continue: currentTheme.primary_continue,
  light: currentTheme.light,                      // #FFFFFF
  dark: currentTheme.dark,                        // #171C17
  red: currentTheme.red,
  sold: currentTheme.sold,
  // WELCOME SUCCESS SCREEN
  success_overlay_bg: hexToRGBA(primary, 0.1),    // Dynamic fallback
  info_box_bg: hexToRGBA(primary, 0.05),          // Dynamic fallback
  info_box_border: hexToRGBA(primary, 0.2),       // Dynamic fallback
  // HEADER
  background_header: currentTheme.background_header,
  nav_text: currentTheme.nav_text,                // #6D786D
  nav_text_active: currentTheme.nav_text_active,  // #00B6E9
  nav_carbon: currentTheme.nav_carbon,            // #00B6E9
  nav_sell_bg: hexToRGBA(primary, 0.08),          // Dynamic fallback
  nav_sell_text: primary,
  search_bg: currentTheme.search_bg,              // #FFFFFF
  search_text: currentTheme.search_text,          // #171C17

  // FARMER DASHBOARD SPECIFIC
  boost_bg: currentTheme.boost_bg,
  gray_empty_text: currentTheme.gray_empty_text,
  action_box_shadow: currentTheme.action_box_shadow,
  white_bg: currentTheme.white_bg,
  dashboard_card_border: currentTheme.dashboard_card_border,

  // ADD CROP (ADD PHOTOS) SCREEN SPECIFIC
  step_bg: hexToRGBA(primary, 0.2),               // Dynamic fallback
  dashed_border: currentTheme.dashed_border,
  btn_shadow_upload: currentTheme.btn_shadow_upload,
  // CARBON CREDITS DASHBOARD SPECIFIC
  carbon_bg_main: currentTheme.carbon_bg_main,
  carbon_bg_light: currentTheme.carbon_bg_light,
  carbon_bg_card: currentTheme.carbon_bg_card,
  carbon_text_main: currentTheme.carbon_text_main,
  carbon_text_secondary: currentTheme.carbon_text_secondary,
  carbon_shadow_card: currentTheme.carbon_shadow_card,
  carbon_shadow_btn: currentTheme.carbon_shadow_btn,
  carbon_shadow_btn_outline: currentTheme.carbon_shadow_btn_outline,
  carbon_gradient_earning: currentTheme.carbon_gradient_earning,
  carbon_shadow_earning: currentTheme.carbon_shadow_earning,
  carbon_text_earning_bg: currentTheme.carbon_text_earning_bg,
  carbon_text_active_bg: currentTheme.carbon_text_active_bg,
  carbon_overlay: currentTheme.carbon_overlay,
  carbon_border_dashed: currentTheme.carbon_border_dashed,
  carbon_step_bg_unselected: currentTheme.carbon_step_bg_unselected,
  carbon_step_text_unselected: currentTheme.carbon_step_text_unselected,
  carbon_border_solid: currentTheme.carbon_border_solid,
  carbon_bg_selected: currentTheme.carbon_bg_selected,
  carbon_border_selected: currentTheme.carbon_border_selected,
  carbon_text_credits: currentTheme.carbon_text_credits,
  carbon_bg_estimated: currentTheme.carbon_bg_estimated,
  carbon_border_estimated: currentTheme.carbon_border_estimated,
  carbon_text_estimated_title: currentTheme.carbon_text_estimated_title,
  carbon_bg_pill: currentTheme.carbon_bg_pill,
  carbon_text_pill: currentTheme.carbon_text_pill,
  carbon_bg_estimated_solid: currentTheme.carbon_bg_estimated_solid,
  carbon_warning_bg: currentTheme.carbon_warning_bg,
  carbon_warning_border: currentTheme.carbon_warning_border,
  carbon_warning_text: currentTheme.carbon_warning_text,
  // UPLOAD PROOF SCREEN SPECIFIC
  carbon_upload_proof_bg: currentTheme.carbon_upload_proof_bg,
  carbon_upload_input_bg: currentTheme.carbon_upload_input_bg,
  carbon_upload_input_bg_alt: currentTheme.carbon_upload_input_bg_alt,
  carbon_upload_tips_bg: currentTheme.carbon_upload_tips_bg,
  carbon_upload_tips_border: currentTheme.carbon_upload_tips_border,
  carbon_upload_tips_text: currentTheme.carbon_upload_tips_text,
  carbon_upload_tips_bullet: currentTheme.carbon_upload_tips_bullet,
  // MY WALLET SCREEN SPECIFIC
  carbon_wallet_btn_bg: currentTheme.carbon_wallet_btn_bg,
  carbon_wallet_btn_text: currentTheme.carbon_wallet_btn_text,
  carbon_wallet_tab_bg: currentTheme.carbon_wallet_tab_bg,
  carbon_wallet_tab_container: currentTheme.carbon_wallet_tab_container,

  // NEW LAYOUT SCREEN SPECIFIC
  layout_bg: currentTheme.layout_bg,
  layout_border: currentTheme.layout_border,
  layout_text_primary: currentTheme.layout_text_primary,
  layout_add_btn: currentTheme.layout_add_btn,
  layout_gradient_avatar: currentTheme.layout_gradient_avatar,

  // ADD CROP SCREEN SPECIFIC
  add_crop_stepper_active: primary,
  add_crop_stepper_inactive: currentTheme.add_crop_stepper_inactive,
  add_crop_stepper_text: currentTheme.add_crop_stepper_text,
  add_crop_stepper_text_inactive: currentTheme.add_crop_stepper_text_inactive,
  add_crop_card_bg: currentTheme.add_crop_card_bg,
  add_crop_card_border: currentTheme.add_crop_card_border,
  add_crop_option_border: currentTheme.add_crop_option_border,
  add_crop_option_active_border: primary,
  add_crop_option_active_bg: hexToRGBA(primary, 0.08),

  // V1 ADD PLOTS STEP 1 SPECIFIC
  v1_crop_search_bg: currentTheme.v1_crop_search_bg,
  v1_crop_search_border: currentTheme.v1_crop_search_border,
  v1_crop_pill_bg: currentTheme.v1_crop_pill_bg,
  v1_crop_pill_border: currentTheme.v1_crop_pill_border,
  v1_crop_pill_icon: primary,
  v1_crop_pill_text: currentTheme.v1_crop_pill_text,
  v1_crop_tab_active: primary,
  v1_crop_tab_inactive: currentTheme.v1_crop_tab_inactive,
  v1_crop_custom_bg: currentTheme.v1_crop_custom_bg,
  v1_crop_custom_border: currentTheme.v1_crop_custom_border,
  v1_crop_custom_icon_bg: currentTheme.v1_crop_custom_icon_bg,
  v1_crop_selected_bg: currentTheme.v1_crop_selected_bg,
  v1_crop_selected_text: currentTheme.v1_crop_selected_text,
  // UNIVERSAL LAYOUT TOKENS
  layout_padding_x: currentTheme.layout_padding_x,
  layout_padding_x_mobile: currentTheme.layout_padding_x_mobile,
  layout_padding_y: currentTheme.layout_padding_y,
  layout_max_width: currentTheme.layout_max_width,
  layout_margin_center: currentTheme.layout_margin_center,
};

export const fonts = {
  poppins: currentFontTheme.poppins,              // Now returns "Nunito"
  manrope: currentFontTheme.manrope,
  publicSans: currentFontTheme.publicSans,
};

export const size = {
  // Figma Reference Metrics (Strict Unit Rules)
  h1: "clamp(1.5rem, 5vw, 1.875rem)",          // KrushiSetu title (24-30px)
  h1_role: "clamp(1.25rem, 4vw, 1.5rem)",     // Choose Your Role title (20-24px)
  h2: "clamp(1.125rem, 3vw, 1.25rem)",          // Welcome! card title (18-20px)
  h3: "clamp(1rem, 2.5vw, 1.125rem)",          // Card Category Title (Buyer/Farmer)
  body: "clamp(0.875rem, 2vw, 1rem)",        // Body / Tagline / Sub-headings
  button: "clamp(1rem, 3vw, 1.125rem)",      // Button text
  small: "clamp(0.75rem, 1.5vw, 0.875rem)",       // Small description text
  mini: "clamp(0.625rem, 1vw, 0.75rem)",        // Tag pill text
  // Legacy mappings for backward compatibility
  title: "clamp(1.5rem, 5vw, 1.875rem)",
  subtitle: "clamp(1.125rem, 3vw, 1.25rem)",
  text: "clamp(1rem, 3vw, 1.125rem)",
  label: "clamp(0.875rem, 2vw, 1rem)",
  formLabel: "clamp(0.75rem, 1.5vw, 0.875rem)",
};